module.exports = __webpack_public_path__ + "static/BT-desktop-12-4c2a9d6d1705852437a54a35cd6ae79d.jpg";